export default "/images/e13a45dc0b4fd7259e56fbc29f51a9a4.avif";